import { getGovHomeServices } from 'govbr.frontend.policy/actions/gov_home_services/gov_home_services';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import useUserRecommendations from './useUserRecommendations';

const addOrigemParam = (services, origem) => {
  if (!services || !Array.isArray(services)) return services;

  return services.map((service) => ({
    ...service,
    path: service.path
      ? `${service.path}${service.path.includes('?') ? '&' : '?'}origem=${origem}`
      : service.path,
  }));
};

export const useBannerServices = () => {
  const dispatch = useDispatch();

  const {
    servicosDestaque,
    servicosMaisAcessados,
    loading: govHomeServicesLoading,
    loaded: govHomeServicesLoaded,
    error: govHomeServicesError,
  } = useSelector((state) => state.gov_home_services);

  const {
    recommendations,
    loading: recommendationsLoading,
    loaded: recommendationsLoaded,
    error: recommendationsError,
  } = useUserRecommendations();

  const { error: historyError } = useSelector((state) => state.user_history);

  const loading = govHomeServicesLoading || recommendationsLoading;

  const loaded = govHomeServicesLoaded && recommendationsLoaded;

  const error = govHomeServicesError || recommendationsError || historyError;

  const loadData = () => {
    dispatch(getGovHomeServices());
  };

  const state = {
    loading,
    error,
    loaded,
    servicosDestaque: addOrigemParam(servicosDestaque, 'destaque_inst'),
    servicosMaisAcessados: addOrigemParam(
      servicosMaisAcessados,
      'maisacessado_inst',
    ),
    recommendations,
    loadData,
    govHomeServicesError,
    recommendationsError,
    historyError,
  };

  return state;
};
